import { ActionAPI, FormAPI, ModalService } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { Value } from '@philips-internal/oswald-ui-core';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import UserContext from '../../utils/user-context';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import VaccineContext from '../../utils/vaccine-context';
import { AppRoutes, FragmentNames, MyChartVaccinesDetailAliases } from '../../codegen';

import './my-chart-vaccine-detail-controller.css';
import DateFormatterUtil from '../../utils/date-utils/date-formatter-util';

interface ReportGenerateResponse {
  uri: string;
}

@Controller({ fragment: FragmentNames.MY_CHART_VACCINES_DETAIL })
class MyChartVaccineDetailController extends BaseController {

  @Inject(MyChartVaccinesDetailAliases.FORM_VACCINE)
    vaccineFormApi!: FormAPI;

  @Inject(MyChartVaccinesDetailAliases.BUTTON_EMAIL)
    emailButtonApi!: ActionAPI;

  @Inject(MyChartVaccinesDetailAliases.BUTTON_DOWNLOAD)
    downloadButtonApi!: ActionAPI;

  @OnMount(MyChartVaccinesDetailAliases.FORM_VACCINE)
  handleMount(event: MountEvent): void {
    const vaccineFormApi = event.target as FormAPI;
    const { sequence } = this.historyService.getCurrentRouteParams();
    vaccineFormApi.setRecord({});
    HttpService.get(APPLICATION_ENDPOINTS.GET_MC_VACCINE_DETAIL, { patientId: UserContext.patientId, sequence: sequence })
      .then(response => response.body as Record<string, Value>)
      .then(data => {
        data.status = data.applicationDate == null
          ? data.status = MessageService.translate('patient.vaccine-preview')
          :  MessageService.translate('patient.vaccine-applied');

        const dateApplicationDate = data.applicationDate as string;
        const dateEstimatedDate = data.estimatedDate as string;
        const nextDoseDate = data.nextDoseDate as string;
        data.applicationDate = dateApplicationDate ? DateFormatterUtil.shortDate(dateApplicationDate) : '';
        data.estimatedDate = dateEstimatedDate ? DateFormatterUtil.shortDate(dateEstimatedDate)  : '';
        data.nextDoseDate = nextDoseDate ? DateFormatterUtil.shortDate(nextDoseDate): '';

        vaccineFormApi.setData(data);
      });
  }

  @OnClick({ target: MyChartVaccinesDetailAliases.BUTTON_DOWNLOAD})
  onDownloadBtnClick(event: ClickEvent): void {
    if (event) {
      this.downloadReport();
    }
  }

  downloadReport(): void {
    const sequence = this.historyService.getCurrentRouteParams().sequence as string;
    this.context.set({ sequence: sequence });
    const body = {
      groupCode: 34,
      vaccineSequence: sequence
    }

    this.context.set({ reportParams: body });

    HttpService.post<ReportGenerateResponse>(APPLICATION_ENDPOINTS.GET_MC_VACCINE_DETAIL_DATA_REPORT,  { patientId: UserContext.patientId },{ body }).then<string>(response => {
      return resolvePath(`${APPLICATION_ENDPOINTS.FILE_VIEW_REPORT_CONTENT}?uri=:uri`, { uri: response.body?.uri });
    }).then(file => {
      const url = file.replace(APPLICATION_ENDPOINTS.FILE_VIEW_REPORT_CONTENT,'');
      const win = window.open(`${AppRoutes.PREVIEW_ATTACHED_FILE_ROUTE}${url}`,'_blank');
      win && win.focus();
    });
  }

  @OnClick({ target: MyChartVaccinesDetailAliases.BUTTON_EMAIL })
  onEmailBtnClick(): void {

    const { sequence } = this.historyService.getCurrentRouteParams();

    const mailParams = {
      contents: [
        {
          patientId: UserContext.patientId,
          vaccineName: VaccineContext.vaccineName,
          vaccineSequence: sequence,
        }
      ],
      groupCode: 34,
    }
    ModalService.openDefault({
      closeable: true,
      contextData: mailParams,
      dockButtons: [],
      focusOnOpen: true,
      fragment: 'send-mail-vaccine',
      title: 'patient.send-by-email',
    });
  }
}
export default MyChartVaccineDetailController;